import React from 'react';

class SMFormFieldTitle extends React.Component {
  
  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }
  
  onFocus(e) {
  }
  
  onBlur(e) {
  }

  render() {
    
    let requiredClass, requiredText;
    if (this.props.isRequired) {
      requiredClass = "icon-form icon-form__required";
      requiredText = "必須";
    } else {
      requiredClass = "icon-form icon-form__optional";
      requiredText = "任意";
    }
    
    return (
      <h2 className="dashboard-title mb20">
        <span className={requiredClass}>{requiredText}</span>{this.props.title}
        <span className="dashboard-title__supplement ml15">
          {this.props.subTitle}
        </span>
      </h2>
    );
  }
}
export default SMFormFieldTitle;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormFieldTitle.jsx